import { render, staticRenderFns } from "./TreeTableNotesPopover.vue?vue&type=template&id=467a1b65&scoped=true"
import script from "./TreeTableNotesPopover.vue?vue&type=script&lang=js"
export * from "./TreeTableNotesPopover.vue?vue&type=script&lang=js"
import style0 from "./TreeTableNotesPopover.vue?vue&type=style&index=0&id=467a1b65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a1b65",
  null
  
)

export default component.exports